import React from 'react';

import type { IIcon } from '../types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 30, className, onClick }, ref) {
  return (
    <svg ref={ref} viewBox='0 0 512 512' onClick={onClick} width={size} height={size} className={className}>
      <path fill='#E2E5E7' d='M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z' />
      <path fill='#B0B7BD' d='M384,128h96L352,0v96C352,113.6,366.4,128,384,128z' />
      <polygon fill='#CAD1D8' points='480,224 384,128 480,128 ' />
      <path fill='#293275' d='M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16V416z' />
      <g>
        <path
          fill='#FFFFFF'
          d='M99.3,322.6l22.3-27.9c6.7-8.7,19.6,2.4,12.3,10.7c-7.7,9.1-15.7,18.9-23.4,29l26.1,32.5 c7,9.6-7,18.8-13.9,9.3L99,346.1l-23.2,30.8c-6.5,9.3-21-1.2-13.7-9.9l25.7-32.6c-8.1-10.1-15.9-20-23.7-29 c-8-9.6,6.9-19.4,12.8-10.5L99.3,322.6z'
        />
        <path
          fill='#FFFFFF'
          d='M157,299.5c0-4.2,3.6-7.8,8.1-7.8c4.1,0,7.6,3.6,7.6,7.8v64.1h34.8c12.5,0,12.8,16.8,0,16.8h-42.3 c-4.5,0-8.1-3.2-8.1-7.8L157,299.5L157,299.5L157,299.5z'
        />
        <path
          fill='#FFFFFF'
          d='M225.5,311.6c2.9-24.8,40.4-29.3,58.1-15.7c8.7,7-0.5,18.2-8.2,12.5c-9.5-6-31-8.8-33.6,4.5 c-3.5,21,52.2,9,51.3,43c-0.9,32.5-48,33.2-65.6,18.7c-4.2-3.5-4.1-9.1-1.8-12.5c3.3-3.3,7-4.5,11.4-0.9 c10.5,7.2,37.5,12.5,39.4-5.6C274.7,336.6,221.5,348,225.5,311.6z'
        />
        <path
          fill='#FFFFFF'
          d='M344.8,322.6l22.3-27.9c6.7-8.7,19.6,2.4,12.3,10.7c-7.7,9.1-15.7,18.9-23.4,29l26.1,32.5 c7,9.6-7,18.8-13.9,9.3l-23.6-30.2l-23.2,30.8c-6.5,9.3-21-1.2-13.7-9.9l25.7-32.6c-8.1-10.1-15.9-20-23.7-29 c-8-9.6,6.9-19.4,12.8-10.5L344.8,322.6z'
        />
      </g>
      <path fill='#CAD1D8' d='M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z' />
    </svg>
  );
});

export default React.memo(Icon);
